module.exports = __webpack_public_path__ + "static/img/device_bg2.a460680.png";